<button class="yco-button"
        ng-disabled="ycoIsProcessing() || ycoDisabled()"
        ng-class="{'yco-button--is-processing': ycoIsProcessing()}">
  <i class="fa fa-spinner fa-pulse fa-fw" ng-if="ycoIsProcessing()"></i>
  <ng-transclude ng-if="!ycoIsProcessing()"></ng-transclude>
</button>
